module.exports = __webpack_public_path__ + "img/send_white.dc341c3a.svg";